/* Ferdinand Möbius — scripts du thème */
(function () {
  'use strict';
  var FM = window.FM || (window.FM = {});
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- événements vers le pixel Shopify (Pilote) ---------- */
  FM.track = function (name, data) {
    data = data || {};
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) { /* */ }
    try { document.dispatchEvent(new CustomEvent('fm:track', { detail: { name: name, data: data } })); } catch (e) { /* */ }
  };

  /* ---------- argent ---------- */
  FM.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || FM.money || '{{amount_with_comma_separator}} €';
    function fmt(n, dec, th, ds) {
      dec = dec == null ? 2 : dec; th = th || ','; ds = ds || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(dec);
      var p = n.split('.');
      var d = p[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return d + (p[1] ? ds + p[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var v = '';
    switch (m && m[1]) {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2, '.', ',');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  };

  /* ---------- toast ---------- */
  var toastEl, toastTimer;
  FM.toast = function (msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3200);
  };

  /* ---------- horloge du drop ---------- */
  var drop = $('#fm-drop');
  var D = drop ? JSON.parse(drop.textContent) : null;
  FM.drop = D;
  function nowS() { return Math.floor(Date.now() / 1000) + (D && D.skew ? D.skew : 0); }
  /* ---------- parrainage et accès anticipé (Pilote) ---------- */
  var storage = {
    get: function (store, k) { try { return store.getItem(k); } catch (e) { return null; } },
    set: function (store, k, v) { try { store.setItem(k, v); } catch (e) { /* stockage indisponible */ } }
  };
  (function captureParams() {
    var q;
    try { q = new URL(window.location.href).searchParams; } catch (e) { return; }
    var ref = (q.get('ref') || '').replace(/[^A-Za-z0-9_-]/g, '').toUpperCase().slice(0, 40);
    if (ref) { storage.set(localStorage, 'fm_ref', ref); FM.track('fm_referral_visit', { ref: ref }); }
    var acces = q.get('acces');
    if (acces) storage.set(sessionStorage, 'fm_acces_token', acces);
  })();
  FM.ref = storage.get(localStorage, 'fm_ref') || null;
  // résultat de la vérification du jeton d'accès, mémorisé pour la session
  FM.access = storage.get(sessionStorage, 'fm_acces') === 'ok';
  function verifyAccess() {
    var token = storage.get(sessionStorage, 'fm_acces_token');
    if (!token || !FM.pilote || !FM.pilote.enabled || FM.access) return;
    fetch(FM.pilote.proxy + '/acces?t=' + encodeURIComponent(token), { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        storage.set(sessionStorage, 'fm_acces', j && j.ok ? 'ok' : 'non');
        if (j && j.ok) { FM.access = true; lastPhase = null; tick(); $$('[data-access-granted]').forEach(function (el) { el.hidden = false; }); $$('[data-access-pending]').forEach(function (el) { el.hidden = true; }); FM.track('fm_early_access_ok', { drop: j.dropName }); }
      })
      .catch(function () { /* nouvelle tentative au prochain chargement */ });
  }

  function phaseAt(t) {
    if (!D || !D.end) return 'none';
    if (D.start && t < D.start) return D.earlyStart && t >= D.earlyStart ? 'early' : 'upcoming';
    if (t < D.end) return D.capacity > 0 && D.reserved >= D.capacity ? 'closed' : 'live';
    if (D.next && t >= D.next) return 'upcoming';
    return 'closed';
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function parts(sec) {
    sec = Math.max(0, sec);
    return { d: Math.floor(sec / 86400), h: Math.floor(sec % 86400 / 3600), m: Math.floor(sec % 3600 / 60), s: sec % 60 };
  }
  var lastPhase = null;
  function tick() {
    if (!D) return;
    var t = nowS();
    var ph = phaseAt(t);
    var target = ph === 'live' ? D.end : (ph === 'upcoming' || ph === 'early' ? (D.start && t < D.start ? D.start : D.next) : D.next);
    if (ph !== lastPhase) {
      document.documentElement.setAttribute('data-drop-phase', ph);
      $$('[data-drop-phase]').forEach(function (el) { if (el !== document.documentElement) el.setAttribute('data-phase', ph); });
      $$('[data-show-phase]').forEach(function (el) {
        var allowed = el.getAttribute('data-show-phase').split(/\s+/);
        el.hidden = allowed.indexOf(ph) === -1;
      });
      $$('[data-drop-gated]').forEach(function (btn) {
        var open = ph === 'live' || (ph === 'early' && FM.access) || btn.hasAttribute('data-always-open');
        if (!open) { btn.setAttribute('disabled', ''); } else if (!btn.hasAttribute('data-unavailable')) { btn.removeAttribute('disabled'); }
      });
      if (lastPhase !== null) FM.track('fm_drop_phase_change', { from: lastPhase, to: ph, drop: D.name });
      lastPhase = ph;
      // progression du drop
      if (D.start && D.end) {
        var p = ph === 'live' ? (t - D.start) / (D.end - D.start) : (ph === 'closed' ? 1 : 0);
        $$('[data-drop-progress]').forEach(function (el) { el.style.setProperty('--p', Math.round(p * 100) + '%'); });
      }
    }
    var rem = target ? target - t : 0;
    var p2 = parts(rem);
    $$('[data-countdown]').forEach(function (el) {
      var u = el.querySelectorAll('[data-u]');
      if (u.length) {
        u.forEach(function (x) {
          var k = x.getAttribute('data-u');
          x.textContent = k === 'd' ? p2.d : pad(p2[k]);
        });
      } else {
        var s = FM.strings || {};
        el.textContent = (p2.d ? p2.d + ' ' + (s.days || 'j') + ' ' : '') + pad(p2.h) + ' ' + (s.hours || 'h') + ' ' + pad(p2.m) + ' ' + (s.minutes || 'min') + (el.hasAttribute('data-seconds') ? ' ' + pad(p2.s) + ' ' + (s.seconds || 's') : '');
      }
    });
    if (rem <= 0 && lastPhase === ph) { lastPhase = null; }
  }
  if (D) { tick(); setInterval(tick, 1000); }
  verifyAccess();

  /* ---------- dates locales ---------- */
  function localDates(root) {
    if (!window.Intl) return;
    $$('[data-local-date]', root).forEach(function (el) {
      var ts = parseInt(el.getAttribute('data-local-date'), 10); if (!ts) return;
      var d = new Date(ts * 1000), f = el.getAttribute('data-fmt'), o;
      if (f === 'day') o = { day: 'numeric', month: 'long' };
      else if (f === 'week') o = { day: 'numeric', month: 'long' };
      else o = { weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' };
      try { el.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'fr', o).format(d).replace(':', 'h'); } catch (e) { /* */ }
    });
  }
  localDates();
  FM.localDates = localDates;

  /* ---------- en-tête ---------- */
  var header = $('[data-header]');
  if (header && header.hasAttribute('data-hide-on-scroll')) {
    var lastY = window.scrollY, ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        header.classList.toggle('is-hidden', y > lastY && y > 240 && !document.body.classList.contains('is-locked'));
        lastY = y; ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- tiroirs ---------- */
  var lastFocus = null;
  FM.openDrawer = function (id) {
    var d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var f = d.querySelector('[data-autofocus]') || d.querySelector('button, a, input, select');
    setTimeout(function () { f && f.focus(); }, 60);
    if (id === 'size-guide') FM.track('fm_size_guide_open', {});
  };
  FM.closeDrawer = function (d) {
    if (typeof d === 'string') d = document.getElementById(d);
    if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
    lastFocus && lastFocus.focus && lastFocus.focus();
  };
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open-drawer]');
    if (o) { e.preventDefault(); FM.openDrawer(o.getAttribute('data-open-drawer')); return; }
    var c = e.target.closest('[data-close-drawer]');
    if (c) { e.preventDefault(); FM.closeDrawer(c.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = $('.drawer.is-open'); if (d) FM.closeDrawer(d);
    var lb = $('.lightbox.is-open'); if (lb) closeLightbox();
  });
  // piège du focus dans un tiroir ouvert
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var d = $('.drawer.is-open .drawer__panel'); if (!d) return;
    var f = $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', d).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  /* ---------- panier ---------- */
  var SECTIONS = 'cart-drawer';
  function postJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { var err = new Error(j.description || j.message || 'error'); err.data = j; throw err; } return j; }); });
  }
  function renderSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var tmp = document.createElement('div'); tmp.innerHTML = sections['cart-drawer'];
      var fresh = tmp.querySelector('[data-cart-body]'), cur = $('#cart-drawer [data-cart-body]');
      if (fresh && cur) cur.replaceWith(fresh);
      var freshFoot = tmp.querySelector('[data-cart-foot]'), curFoot = $('#cart-drawer [data-cart-foot]');
      if (freshFoot && curFoot) curFoot.replaceWith(freshFoot);
      else if (!freshFoot && curFoot) curFoot.remove();
      else if (freshFoot && !curFoot) { var panel = $('#cart-drawer .drawer__panel'); panel && panel.appendChild(freshFoot); }
    }
  }
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count > 0 ? count : ''; el.setAttribute('data-count', count); });
  }
  FM.refreshCart = function () {
    return fetch(FM.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); FM.cart = c; return c; });
  };
  FM.addToCart = function (items, opts) {
    opts = opts || {};
    return postJSON(FM.routes.cartAdd + '.js', { items: items, sections: SECTIONS, sections_url: window.location.pathname })
      .then(function (res) {
        renderSections(res.sections);
        return FM.refreshCart().then(function (c) {
          if (opts.discount) return applyDiscount(opts.discount).then(function () { return c; });
          return c;
        });
      })
      .then(function (c) {
        if (!opts.silent) FM.openDrawer('cart-drawer');
        items.forEach(function (it) { FM.track('fm_add_to_cart', { variant_id: it.id, quantity: it.quantity || 1, source: opts.source || 'product' }); });
        return c;
      });
  };
  function applyDiscount(code) {
    var codes = (FM.cart && FM.cart.discount_codes || []).map(function (d) { return d.code; });
    if (codes.indexOf(code) === -1) codes.push(code);
    return postJSON(FM.routes.cartUpdate + '.js', { discount: codes.join(','), sections: SECTIONS }).then(function (res) { renderSections(res.sections); });
  }
  FM.changeLine = function (key, qty) {
    return postJSON(FM.routes.cartChange + '.js', { id: key, quantity: qty, sections: SECTIONS, sections_url: window.location.pathname })
      .then(function (res) { renderSections(res.sections); updateCount(res.item_count); FM.cart = res; return res; });
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (b) {
      var line = b.closest('[data-line-key]'); if (!line) return;
      var input = line.querySelector('[data-qty-input]');
      var q = Math.max(0, parseInt(input.value, 10) + parseInt(b.getAttribute('data-qty-step'), 10));
      line.style.opacity = '.5';
      FM.changeLine(line.getAttribute('data-line-key'), q).catch(function (err) { FM.toast(err.message || FM.strings.error); line.style.opacity = ''; });
      return;
    }
    var r = e.target.closest('[data-remove-line]');
    if (r) {
      e.preventDefault();
      var l2 = r.closest('[data-line-key]');
      l2.style.opacity = '.5';
      FM.changeLine(l2.getAttribute('data-line-key'), 0);
      return;
    }
    var u = e.target.closest('[data-upsell-add]');
    if (u) {
      e.preventDefault();
      u.classList.add('is-loading'); u.setAttribute('disabled', '');
      FM.addToCart([{ id: parseInt(u.getAttribute('data-upsell-add'), 10), quantity: 1 }], { silent: true, discount: u.getAttribute('data-discount') || null, source: 'cart_upsell' })
        .then(function () { FM.track('fm_cart_upsell_add', { variant_id: u.getAttribute('data-upsell-add') }); })
        .catch(function (err) { FM.toast(err.message || FM.strings.error); u.classList.remove('is-loading'); u.removeAttribute('disabled'); });
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var line = input.closest('[data-line-key]');
    FM.changeLine(line.getAttribute('data-line-key'), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ---------- fiche pièce ---------- */
  function initProduct(root) {
    var form = $('[data-product-form]', root); if (!form) return;
    var json = $('[data-product-json]', root); if (!json) return;
    var product = JSON.parse(json.textContent);
    var idInput = $('input[name="id"]', form);
    var btn = $('[data-add-btn]', root);
    var label = btn && $('.btn__label', btn);
    var priceEl = $('[data-price]', root);
    var stickyPrice = $('[data-sticky-price]');
    var gallery = $('[data-gallery]', root);
    var labels = $$('[data-option-current]', root);

    function selected() {
      return $$('[data-option]', root).map(function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function markAvailability(opts) {
      $$('[data-option]', root).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var v = findVariant(test);
          inp.closest('.chip').classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function update(fromUser) {
      var opts = selected();
      labels.forEach(function (l) { var i = parseInt(l.getAttribute('data-option-current'), 10); l.textContent = opts[i] || ''; });
      var v = findVariant(opts);
      markAvailability(opts);
      if (!v) {
        btn && btn.setAttribute('disabled', ''); btn && btn.setAttribute('data-unavailable', '');
        label && (label.textContent = FM.strings.unavailable); return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = FM.formatMoney(v.price) + (v.compare_at_price > v.price ? ' <s>' + FM.formatMoney(v.compare_at_price) + '</s>' : '');
      if (stickyPrice) stickyPrice.textContent = FM.formatMoney(v.price);
      var gated = btn && btn.hasAttribute('data-drop-gated') && !btn.hasAttribute('data-always-open');
      var curPhase = document.documentElement.getAttribute('data-drop-phase');
      var phaseOpen = !gated || curPhase === 'live' || (curPhase === 'early' && FM.access) || !FM.drop;
      if (btn) {
        if (v.available) { btn.removeAttribute('data-unavailable'); if (phaseOpen) btn.removeAttribute('disabled'); label && (label.textContent = label.getAttribute('data-default') || FM.strings.addToCart); }
        else { btn.setAttribute('disabled', ''); btn.setAttribute('data-unavailable', ''); label && (label.textContent = FM.strings.soldOut); }
      }
      if (fromUser) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
        if (v.featured_media && gallery) {
          var item = gallery.querySelector('[data-media-id="' + v.featured_media.id + '"]');
          if (item) {
            if (window.innerWidth < 1000) gallery.scrollTo({ left: item.offsetLeft - gallery.offsetLeft - 16, behavior: 'smooth' });
            else if (item !== gallery.firstElementChild) gallery.insertBefore(item, gallery.firstElementChild);
          }
        }
        FM.track('fm_variant_select', { product_id: product.id, variant_id: v.id, options: opts });
      }
      document.dispatchEvent(new CustomEvent('fm:variant', { detail: { variant: v, product: product } }));
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-option]')) update(true); });
    update(false);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.hasAttribute('disabled')) return;
      btn.classList.add('is-loading');
      var fd = new FormData(form);
      var item = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) || 1, properties: {} };
      fd.forEach(function (val, key) {
        var m = key.match(/^properties\[(.+)\]$/); if (m && val) item.properties[m[1]] = val;
      });
      if (fd.get('selling_plan')) item.selling_plan = parseInt(fd.get('selling_plan'), 10);
      if (D && D.name && btn.hasAttribute('data-drop-gated')) item.properties._drop = D.name;
      FM.addToCart([item], { source: 'product' })
        .catch(function (err) { FM.toast(err.message || FM.strings.error); })
        .then(function () { btn.classList.remove('is-loading'); });
    });

    // barre d'achat mobile
    var sticky = $('[data-sticky-buy]');
    if (sticky && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e0 = en[0];
        sticky.classList.toggle('is-visible', !e0.isIntersecting && e0.boundingClientRect.top < 0);
      }).observe(btn);
      var sb = $('[data-sticky-submit]', sticky);
      sb && sb.addEventListener('click', function () { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); if (!btn.disabled) form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }

    // points de la galerie mobile
    var dots = $('[data-gallery-dots]', root);
    if (gallery && dots) {
      gallery.addEventListener('scroll', function () {
        var w = gallery.firstElementChild ? gallery.firstElementChild.getBoundingClientRect().width : 1;
        var i = Math.round(gallery.scrollLeft / (w + 8));
        $$('span', dots).forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }, { passive: true });
    }
    FM.track('fm_product_view', { product_id: product.id, handle: product.handle, phase: document.documentElement.getAttribute('data-drop-phase') });
  }
  $$('[data-product]').forEach(initProduct);

  /* ---------- ajout rapide depuis une carte ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-quick-add]');
    if (!f) return;
    e.preventDefault();
    var b = $('button[type=submit]', f); b && b.classList.add('is-loading');
    var fd = new FormData(f);
    var it = { id: parseInt(fd.get('id'), 10), quantity: 1, properties: {} };
    if (D && D.name && f.hasAttribute('data-drop-item')) it.properties._drop = D.name;
    FM.addToCart([it], { source: 'card' }).catch(function (err) { FM.toast(err.message || FM.strings.error); }).then(function () { b && b.classList.remove('is-loading'); });
  });

  /* ---------- visionneuse ---------- */
  var lb = $('[data-lightbox]');
  function closeLightbox() { if (!lb) return; lb.classList.remove('is-open'); document.body.classList.remove('is-locked'); }
  document.addEventListener('click', function (e) {
    var z = e.target.closest('[data-zoom]');
    if (z && lb) {
      var track = $('[data-lightbox-track]', lb);
      lb.classList.add('is-open'); document.body.classList.add('is-locked');
      var target = track.querySelector('[data-zoom-target="' + z.getAttribute('data-zoom') + '"]');
      if (target) track.scrollLeft = target.offsetLeft;
      $('[data-lightbox-close]', lb).focus();
      return;
    }
    if (e.target.closest('[data-lightbox-close]')) closeLightbox();
  });

  /* ---------- vidéos (héro, médias) ---------- */
  $$('video[data-autoplay]').forEach(function (v) {
    v.muted = true; v.playsInline = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.body.getAttribute('data-motion') === 'off';
    if (reduce) { v.removeAttribute('autoplay'); v.pause(); return; }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { var p = v.play(); p && p.catch(function () {}); } else v.pause();
      }, { threshold: .15 }).observe(v);
    }
  });
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-sound]');
    if (!s) return;
    var v = document.getElementById(s.getAttribute('data-sound')); if (!v) return;
    v.muted = !v.muted; if (!v.muted) { v.currentTime = 0; v.play(); }
    s.setAttribute('aria-pressed', String(!v.muted));
    FM.track('fm_video_sound', { on: !v.muted });
  });
  $$('video').forEach(function (v) {
    var sent = false;
    v.addEventListener('timeupdate', function () {
      if (!sent && v.duration && v.currentTime / v.duration > .5) { sent = true; FM.track('fm_video_half', { src: v.currentSrc.split('?')[0].split('/').pop() }); }
    });
  });

  /* ---------- liste d'attente / inscriptions ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-waitlist]');
    if (!f) return;
    var msg = $('[data-form-msg]', f);
    var fd = new FormData(f);
    var email = (fd.get('contact[email]') || '').trim();
    var phone = (fd.get('contact[phone]') || '').trim();
    var wantsSms = !!fd.get('consent_sms'), wantsWa = !!fd.get('consent_whatsapp'), wantsEmail = !!fd.get('consent_email');
    if ((wantsSms || wantsWa) && !phone) {
      e.preventDefault();
      msg.className = 'form-msg form-msg--err'; msg.textContent = f.getAttribute('data-msg-phone'); return;
    }
    if (!FM.pilote || !FM.pilote.enabled) return; // envoi natif Shopify
    e.preventDefault();
    var b = $('button[type=submit]', f); b && b.classList.add('is-loading');
    var payload = {
      email: email, phone: phone, first_name: fd.get('contact[first_name]') || '',
      consent: { email: wantsEmail, sms: wantsSms, whatsapp: wantsWa },
      source: f.getAttribute('data-source') || 'site', product: f.getAttribute('data-product-handle') || null,
      drop: D && D.name, locale: FM.locale, page: window.location.pathname,
      ref: FM.ref || null
    };
    fetch(FM.pilote.proxy + '/subscribe', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () {
        msg.className = 'form-msg form-msg--ok'; msg.textContent = f.getAttribute('data-msg-ok');
        f.reset();
        storage.set(localStorage, 'fm_subscribed', '1');
        FM.track('fm_waitlist_submit', { source: payload.source, email: !!email, sms: wantsSms, whatsapp: wantsWa, ref: !!FM.ref });
      })
      .catch(function () {
        // repli : formulaire client natif
        f.removeAttribute('data-waitlist'); f.submit();
      })
      .then(function () { b && b.classList.remove('is-loading'); });
  });

  /* ---------- tests A/B pilotés par Pilote ---------- */
  function abBucket(key, variants) {
    var store = {};
    try { store = JSON.parse(localStorage.getItem('fm_ab') || '{}'); } catch (e) { /* */ }
    if (store[key] && variants.some(function (v) { return v.id === store[key]; })) return store[key];
    var total = variants.reduce(function (a, v) { return a + (v.weight || 1); }, 0), r = Math.random() * total, acc = 0, pick = variants[0].id;
    for (var i = 0; i < variants.length; i++) { acc += variants[i].weight || 1; if (r <= acc) { pick = variants[i].id; break; } }
    store[key] = pick;
    try { localStorage.setItem('fm_ab', JSON.stringify(store)); } catch (e) { /* */ }
    return pick;
  }
  FM.ab = {};
  if (FM.experiments && typeof FM.experiments === 'object') {
    Object.keys(FM.experiments).forEach(function (key) {
      var ex = FM.experiments[key];
      if (!ex || !ex.active || !ex.variants || !ex.variants.length) return;
      if (ex.templates && ex.templates.indexOf(document.body.className.match(/template-([\w-]+)/)[1]) === -1) return;
      var els = $$('[data-ab="' + key + '"]');
      if (!els.length) return;
      var vid = abBucket(key, ex.variants);
      var v = ex.variants.filter(function (x) { return x.id === vid; })[0];
      FM.ab[key] = vid;
      els.forEach(function (el) {
        if (v.text != null) { var lab = el.querySelector('.btn__label') || el; lab.textContent = v.text; if (lab.hasAttribute('data-default')) lab.setAttribute('data-default', v.text); }
        if (v.hide) el.hidden = true;
        if (v.attr) Object.keys(v.attr).forEach(function (a) { el.setAttribute(a, v.attr[a]); });
      });
      FM.track('fm_ab_exposure', { experiment: ex.id || key, key: key, variant: vid });
    });
  }

  /* ---------- recherche prédictive ---------- */
  $$('[data-predictive]').forEach(function (input) {
    var out = document.getElementById(input.getAttribute('data-predictive'));
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch(FM.routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) { var t = document.createElement('div'); t.innerHTML = html; var c = t.querySelector('[data-predictive-results]'); out.innerHTML = c ? c.innerHTML : ''; });
      }, 220);
    });
  });

  /* ---------- recommandations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-recommendations');
    if (!('IntersectionObserver' in window)) return load();
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' });
    io.observe(el);
    function load() {
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var t = document.createElement('div'); t.innerHTML = html;
        var c = t.querySelector('[data-recommendations]');
        if (c && c.innerHTML.trim().length) { el.innerHTML = c.innerHTML; el.hidden = false; }
      });
    }
  });

  /* ---------- apparitions ---------- */
  if ('IntersectionObserver' in window) {
    var io2 = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io2.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    $$('.reveal-once').forEach(function (el) { io2.observe(el); });
  } else {
    $$('.reveal-once').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- cercle : page « Mon rang », tableau de bord ambassadeur, votes ---------- */
  function circleToken(root) {
    var t = root && root.getAttribute('data-token');
    if (t) return t;
    try { return new URL(window.location.href).searchParams.get('t'); } catch (e) { return null; }
  }
  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-copy]');
    if (!c) return;
    var txt = c.getAttribute('data-copy');
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(function () { FM.toast(FM.strings.copied || 'Lien copié'); }, function () { window.prompt('', txt); });
    else window.prompt('', txt);
    FM.track('fm_referral_copy', {});
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-circle-instagram]');
    if (!f || !FM.pilote || !FM.pilote.enabled) return;
    e.preventDefault();
    var fd = new FormData(f), msg = $('[data-form-msg]', f);
    fetch(FM.pilote.proxy + '/cercle', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ t: fd.get('t'), instagram: fd.get('instagram') }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.error || ''); return j; }); })
      .then(function () { if (msg) { msg.className = 'form-msg form-msg--ok'; msg.textContent = FM.strings.saved || 'Enregistré.'; } })
      .catch(function (err) { if (msg) { msg.className = 'form-msg form-msg--err'; msg.textContent = err.message || FM.strings.error; } });
  });

  // tableau de bord ambassadeur (section « ambassador » : arrivée avec ?t=<jeton signé>)
  $$('[data-ambassador]').forEach(function (root) {
    var token = circleToken(root);
    var empty = $('[data-ambassador-empty]', root), body = $('[data-ambassador-body]', root);
    if (!token || !FM.pilote || !FM.pilote.enabled) { if (empty) empty.hidden = false; return; }
    fetch(FM.pilote.proxy + '/cercle?format=json&t=' + encodeURIComponent(token), { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.ok) { if (empty) empty.hidden = false; return; }
        var s = FM.strings;
        var tiers = (j.tiers || []).map(function (t) {
          var state = t.status === 'granted' ? (s.tierGranted || 'Obtenu') + (t.code ? ' · ' + escapeHtml(t.code) : '') : t.reached ? (s.tierReached || 'Atteint, en cours') : Math.max(0, t.referrals - j.referrals) + ' ' + (s.tierLeft || 'restant(s)');
          return '<li class="cm-tier"><span>' + escapeHtml(t.label) + ' <span class="t-soft">(' + t.referrals + ')</span></span><span>' + state + '</span></li>';
        }).join('');
        body.innerHTML = '<p class="t-h3">' + (s.rankLabel || 'Votre rang') + ' : n° ' + j.rank + ' / ' + j.total + '</p>' +
          '<p>' + j.referrals + ' ' + (s.referrals || 'filleul(s) inscrit(s)') + '</p>' +
          '<p class="cm-share"><code>' + escapeHtml(j.shareUrl) + '</code> <button type="button" class="btn btn--ghost" data-copy="' + escapeHtml(j.shareUrl) + '">' + (s.copy || 'Copier') + '</button></p>' +
          '<ul class="cm-tiers">' + tiers + '</ul>';
        body.hidden = false;
        var voteRoot = $('[data-vote-root]', root); if (voteRoot) { voteRoot.setAttribute('data-token', token); initVote(voteRoot); }
      })
      .catch(function () { if (empty) empty.hidden = false; });
  });

  // votes du cercle (section « vote » et page du proxy)
  function initVote(root) {
    if (root.getAttribute('data-vote-ready')) return;
    root.setAttribute('data-vote-ready', '1');
    var token = circleToken(root);
    if (!token || !FM.pilote || !FM.pilote.enabled) { var em = $('[data-vote-empty]', root); if (em) em.hidden = false; return; }
    var s = FM.strings;
    function render(polls, mine) {
      if (!polls.length) { root.innerHTML = '<p class="t-soft">' + (s.noPoll || 'Aucun vote en cours.') + '</p>'; return; }
      root.innerHTML = polls.map(function (p) {
        var total = p.results ? p.results.total : 0;
        return '<fieldset class="cm-poll" data-poll="' + escapeHtml(p.id) + '"><legend class="t-h3">' + escapeHtml(p.question) + '</legend>' +
          p.options.map(function (o) {
            var n = p.results && p.results.counts[o.id] || 0, pct = total ? Math.round(n / total * 100) : 0;
            return '<label class="cm-option' + (mine[p.id] === o.id ? ' is-mine' : '') + '"><input type="radio" name="poll-' + escapeHtml(p.id) + '" value="' + escapeHtml(o.id) + '"' + (mine[p.id] === o.id ? ' checked' : '') + '><span class="cm-option__label">' + escapeHtml(o.label) + '</span><span class="cm-option__bar" style="--p:' + pct + '%"></span><span class="cm-option__pct t-small">' + pct + ' %</span></label>';
          }).join('') +
          '<p class="t-small t-soft">' + total + ' ' + (s.ballots || 'vote(s)') + '</p></fieldset>';
      }).join('');
    }
    function load() {
      return fetch(FM.pilote.proxy + '/vote?t=' + encodeURIComponent(token), { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) { if (j && j.ok) render(j.polls || [], j.mine || {}); else root.innerHTML = '<p class="t-soft">' + (s.invalidLink || 'Lien invalide.') + '</p>'; });
    }
    root.addEventListener('change', function (e) {
      var inp = e.target.closest('input[type=radio]'); if (!inp) return;
      var poll = inp.closest('[data-poll]').getAttribute('data-poll');
      fetch(FM.pilote.proxy + '/vote', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ t: token, poll: poll, option: inp.value }) })
        .then(function (r) { return r.json(); })
        .then(function (j) { if (j && j.ok) { FM.track('fm_vote', { poll: poll }); return load(); } FM.toast(j && j.error || FM.strings.error); })
        .catch(function () { FM.toast(FM.strings.error); });
    });
    load().catch(function () { root.innerHTML = '<p class="t-soft">' + FM.strings.error + '</p>'; });
  }
  $$('[data-vote-root]').forEach(initVote);

  /* ---------- sortie de page : proposition d'inscription, une fois par session ---------- */
  (function exitIntent() {
    var box = $('[data-exit-intent]');
    if (!box || !D || !D.end) return;
    if (storage.get(sessionStorage, 'fm_exit') || storage.get(localStorage, 'fm_subscribed')) return;
    if (/template-(cart|checkout)/.test(document.body.className)) return;
    var shown = false;
    function show(reason) {
      if (shown) return; shown = true;
      storage.set(sessionStorage, 'fm_exit', '1');
      box.hidden = false; box.classList.add('is-open');
      var f = box.querySelector('input[type=email]'); if (f) setTimeout(function () { f.focus(); }, 80);
      FM.track('fm_exit_intent', { reason: reason, phase: document.documentElement.getAttribute('data-drop-phase') });
    }
    box.addEventListener('click', function (e) { if (e.target.closest('[data-exit-close]') || e.target === box) { box.classList.remove('is-open'); box.hidden = true; } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) { box.classList.remove('is-open'); box.hidden = true; } });
    var touch = window.matchMedia('(pointer: coarse)').matches;
    if (!touch) {
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0 && Date.now() - start > 4000) show('cursor'); });
    } else {
      var lastY = window.scrollY, lastT = Date.now();
      window.addEventListener('scroll', function () {
        var y = window.scrollY, t = Date.now(), dy = lastY - y, dt = Math.max(1, t - lastT);
        if (dy > 0 && dy / dt > 1.6 && lastY > window.innerHeight && Date.now() - start > 4000) show('scroll');
        lastY = y; lastT = t;
      }, { passive: true });
      window.addEventListener('popstate', function () { show('back'); });
      // entrée d'historique neutre : le premier « retour » déclenche popstate sans quitter la page
      if (window.history && history.pushState && !history.state) { try { history.replaceState({ fm: 1 }, ''); history.pushState({ fm: 2 }, ''); } catch (e) { /* */ } }
    }
    var start = Date.now();
  })();

  /* ---------- éditeur de thème ---------- */
  document.addEventListener('shopify:section:load', function (e) { $$('[data-product]', e.target).forEach(initProduct); tick(); lastPhase = null; tick(); });

  /* ---------- signal de profondeur de lecture ---------- */
  var depthSent = {};
  window.addEventListener('scroll', function () {
    var h = document.documentElement.scrollHeight - window.innerHeight; if (h <= 0) return;
    var p = Math.round(window.scrollY / h * 100);
    [50, 90].forEach(function (m) { if (p >= m && !depthSent[m]) { depthSent[m] = 1; FM.track('fm_scroll_depth', { depth: m, template: document.body.className.split(' ')[0] }); } });
  }, { passive: true });
})();
